import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: '90%',
    marginTop: theme.spacing(4),
    borderRadius: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      width: 550,
      marginTop: 0,
      zIndex: 2,
    },
  },
  whiteColor: {
    color: theme.palette.common.white,
  },
  textDescription: {
    color: theme.palette.common.white,
    lineHeight: 1.3,
  },
}));
